<template>
  <v-btn class="mr-md-5 mr-3 language_button" icon size="26" :ripple="false">
    <v-avatar :image="selectedFlag" size="26" />

    <v-menu activator="parent" origin="top" scroll-strategy="block" offset="19">
      <v-list class="d-flex flex-column ga-0 pa-0" color="primary" base-color="primary" elevation="1">
        <v-list-item
          v-for="(item, index) in items"
          :key="index"
          class="language_button_item px-3 py-2"
          @click="switchLanguage(item.lang)"
        >
          <v-avatar :image="item.prependAvatar" size="26" />
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-btn>
</template>

<script lang="ts" setup>
import { useRouter, useRoute } from 'vue-router'
import { ref, onMounted } from 'vue'

import flagUK from '@/assets/flags/Flag_of_United_Kingdom.svg'
import flagFR from '@/assets/flags/Flag_of_France.svg'

const router = useRouter()
const route = useRoute()

const items = [
  {
    lang: 'en',
    title: 'English',
    prependAvatar: flagUK,
  },
  {
    lang: 'fr',
    title: 'French',
    prependAvatar: flagFR,
  },
]

const selectedFlag = ref(flagUK)

onMounted(() => {
  const lang = route.params.lang || window.location.pathname.split('/')[1]
  const match = items.find(i => i.lang === lang)
  if (match) selectedFlag.value = match.prependAvatar
})

const switchLanguage = (lang: string) => {
  const selected = items.find(i => i.lang === lang)
  if (selected) selectedFlag.value = selected.prependAvatar

  const currentUrl = window.location.href
  const pathParts = window.location.pathname.split('/').filter(Boolean)
  if (['en', 'fr'].includes(pathParts[0])) pathParts.shift()

  const newPath = `/${lang}/${pathParts.join('/')}`
  const fullPath = `${newPath}${window.location.search}${window.location.hash}`

  console.groupCollapsed('[Language Switch]')
  console.log('Current URL:', currentUrl)
  console.log('Selected Language:', lang)
  console.log('Navigating to:', fullPath)
  console.groupEnd()

  window.location.href = fullPath
}

</script>

<style lang="scss">

// Hide default Weglot language switcher
.weglot-container {
  display: none !important;
}

// Syle the Language Switcher button items
.language_button_item {

    // Ensure items are flex and aligned
    .v-list-item__content {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: row;
        gap: 10px;
    }
}

</style>